// src/pages/Categories/CategoryListPage.jsx

import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CategoriesList from "./CategoriesList"; 

const ViewCategoryPage = () => {
  return (
    <MasterLayout>
      {/* Breadcrumb for page title and navigation */}
      <Breadcrumb
        id="title"
        title="Categories List"
      />
      <CategoriesList />
    </MasterLayout>
  );
};

export default ViewCategoryPage;
